/**
 * The Chosen mark, its points rounded to whole units of its 1531 x 1777 box.
 */
const MARK_PATHS = [
  'M763 0C766 1 770 4 773 6C793 17 812 28 832 40L985 128L1530 442C1530 576 1530 710 1529 844C1528 899 1527 954 1527 1009L1526 1290C1526 1305 1526 1321 1525 1337L767 1777C765 1774 766 1742 766 1737L767 1601L768 959C768 935 769 908 768 883C739 869 705 848 676 831L498 729L3 443C63 406 128 370 190 334L684 47C708 33 740 15 763 0Z',
  'M631 1058C641 1066 656 1099 663 1111L707 1194L708 1104C716 1108 726 1114 733 1118C731 1169 733 1221 731 1272C731 1272 730 1273 729 1274C720 1268 699 1223 692 1211C680 1188 665 1162 654 1139C652 1149 653 1161 653 1171C652 1190 653 1209 652 1228C644 1224 635 1219 628 1214C626 1195 628 1156 628 1136C628 1119 628 1074 631 1058Z',
  'M571 1024C578 1027 587 1033 594 1038C594 1090 594 1142 593 1194C585 1189 577 1185 568 1180L571 1024Z',
  'M405 928C410 930 426 940 430 942C433 950 437 968 439 977C443 996 448 1016 453 1035C461 1018 469 986 477 972C481 971 483 974 484 977C490 1006 501 1039 505 1068C514 1046 522 1022 530 1000C538 1006 548 1011 556 1016C550 1030 544 1048 538 1063C535 1073 512 1138 507 1144L505 1143C498 1138 494 1114 492 1104L479 1051C475 1062 461 1104 455 1113C454 1113 453 1114 452 1113C446 1107 443 1086 441 1079L429 1029C425 1011 421 993 416 975C413 961 408 943 405 928Z',
  'M632 836C634 837 637 839 639 841C647 856 655 874 662 890L709 989C710 979 710 962 711 951L712 882C721 886 729 891 737 896C737 937 736 978 735 1019C734 1038 734 1065 732 1084C730 1083 727 1080 725 1078C716 1062 708 1044 701 1027C686 995 671 963 655 931C652 966 654 1003 652 1038C644 1033 635 1028 627 1023C627 985 629 945 630 906C630 886 630 855 632 836Z',
  'M509 765C537 778 569 800 598 815L597 853C578 844 552 827 533 817C532 829 532 841 532 853C548 862 564 872 580 881C580 894 579 906 579 919C570 914 539 895 532 893L531 894C530 905 530 916 530 928C551 940 573 952 594 965C594 977 593 991 593 1003C568 987 531 967 504 952C505 930 505 904 505 882C505 843 507 804 509 765Z',
  'M417 714C451 713 465 747 474 774C468 777 462 780 456 784C453 772 440 746 426 751C412 768 443 802 452 815C459 825 465 834 470 845C481 866 487 911 462 924C455 928 445 925 438 922C436 921 435 920 433 919C409 905 396 874 389 848C396 847 403 846 410 844C414 861 422 877 437 887C442 890 451 890 453 883C460 859 438 839 424 821C405 795 392 761 404 728C406 721 411 718 417 714Z',
  'M134 551C142 555 151 560 159 564C158 589 157 614 157 639C169 648 198 663 212 671C214 650 214 618 215 597C222 600 233 607 240 611C240 637 238 662 237 688C237 725 236 761 235 798C229 796 216 788 210 785C211 760 212 735 212 710C194 699 175 688 156 678C155 702 155 728 155 752C147 748 138 743 130 739C132 676 131 613 134 551Z',
  'M37 502C77 499 102 549 113 580C107 584 100 588 93 592C88 576 69 536 44 543C20 550 23 595 30 614C37 633 45 650 64 660C79 664 84 660 92 649C97 658 107 674 111 683C40 769 -53 531 37 502Z',
];

const MARK_HOLLOW_PATH =
  'M293 651C302 651 312 652 320 656C369 686 393 777 370 829C365 840 354 847 343 850C333 851 326 850 317 845C289 828 274 797 265 767C254 734 249 663 293 651ZM304 691C261 705 287 810 333 810C376 793 348 692 304 691Z';

/**
 * The picture a catalogue image shows when it has none: the brand mark, in the
 * current text colour.
 */
export function FallbackMark() {
  return (
    <svg
      aria-hidden
      className="h-auto w-2/5 max-w-24"
      fill="currentColor"
      viewBox="0 0 1531 1777"
    >
      {MARK_PATHS.map((path) => (
        <path
          key={path}
          d={path}
        />
      ))}
      <path
        clipRule="evenodd"
        d={MARK_HOLLOW_PATH}
        fillRule="evenodd"
      />
    </svg>
  );
}
